var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3069_9342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.57153 8.28577C8.57153 6.07663 10.3624 4.28577 12.5715 4.28577H30.8573L39.4287 12.8572V39.7143C39.4287 41.9235 37.6378 43.7143 35.4287 43.7143H12.5715C10.3624 43.7143 8.57153 41.9235 8.57153 39.7143V8.28577Z",
    fill: "url(#paint0_linear_3069_9342)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8573 12.8572L39.4287 12.8572L30.8573 4.28575L30.8573 10.8572C30.8573 11.9617 31.7527 12.8572 32.8573 12.8572Z",
    fill: "#F17732"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M20.2612 31.7143V20.9143H24.8435C25.4812 20.9143 26.0572 21.0686 26.5715 21.3772C27.0961 21.6754 27.5075 22.0869 27.8058 22.6114C28.1144 23.136 28.2687 23.7274 28.2687 24.3857C28.2687 25.0543 28.1144 25.656 27.8058 26.1909C27.5075 26.7257 27.0961 27.1526 26.5715 27.4714C26.0572 27.78 25.4812 27.9343 24.8435 27.9343H22.5755V31.7143H20.2612ZM22.5447 25.8514H24.5812C24.8281 25.8514 25.0492 25.7897 25.2447 25.6663C25.4401 25.5326 25.5944 25.3577 25.7075 25.1417C25.8309 24.9257 25.8927 24.6789 25.8927 24.4012C25.8927 24.1234 25.8309 23.8817 25.7075 23.676C25.5944 23.46 25.4401 23.2954 25.2447 23.1823C25.0492 23.0589 24.8281 22.9972 24.5812 22.9972H22.5447V25.8514Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3069_9342",
    x1: 24.0001,
    y1: 43.7143,
    x2: 24.0001,
    y2: 4.28577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F18360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE4E09"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3069_9342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptIcon);
export default __webpack_public_path__ + "static/media/ppt-icon.341ad2d3772575ef3c2b7fb6257bae42.svg";
export { ForwardRef as ReactComponent };